import { Drawer } from "antd";
import { observer } from "mobx-react-lite";
import React, { createContext, useContext } from "react";
import renderHTML from "react-render-html";
import EbendoDailyProductionStore from "../store/ebendodailyproductionstore";
const EbendoStoreCtx = createContext(EbendoDailyProductionStore);
export const EbendoRemarkPane = observer(() => {
  const ebendoDailyProductionStore = useContext(EbendoStoreCtx);

  return (
    <Drawer
      title={ebendoDailyProductionStore.remarkObj?.title}
      placement="right"
      width={'30%'}
      closable={true}
      destroyOnClose={true}
      onClose={() => {
        ebendoDailyProductionStore.showRemarkPane = false;
      }}
      visible={ebendoDailyProductionStore.showRemarkPane}
    >
      {ebendoDailyProductionStore.remarkObj &&
        renderHTML(ebendoDailyProductionStore?.remarkObj?.remark)}
    </Drawer>
  );
});

